import React from "react";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { compactPrice } from "@/helpers/compactPrice";
import GitchaLogo from "@/images/gitcha-logo.svg";

const initialsOf = (details) =>
  `${String(details?.FirstName || "").charAt(0)}${String(details?.LastName || "").charAt(0)}`.toUpperCase();

export const budgetPhrase = (min, max) => {
  const low = Number(min) > 0 ? compactPrice(Number(min)) : null;
  const high = Number(max) > 0 ? compactPrice(Number(max)) : null;
  if (low && high) return `${low} to ${high}`;
  if (high) return `Up to ${high}`;
  if (low) return `${low} and up`;
  return null;
};

export const listingOf = (wantListing, wantListingTitle) => ({
  title: wantListingTitle || wantListing?.Title_Text || null,
  budget: wantListing ? budgetPhrase(wantListing.Budget_mn, wantListing.Budget_mx) : null,
});

export const Face = ({ details }) =>
  details?.Img ? (
    <img className="pro-art__face" src={details.Img} alt="" />
  ) : (
    <span className="pro-art__face pro-art__face--initials" aria-hidden="true">
      {initialsOf(details)}
    </span>
  );

const ListingCard = ({ listing, compact }) => (
  <div className={`pro-art__listing${compact ? " is-compact" : ""}`}>
    <span className="pro-art__video" aria-hidden="true">
      <span className="pro-art__play" />
    </span>
    <span className="pro-art__meta">
      {listing.budget ? <b>{listing.budget}</b> : null}
      <span>{listing.title || "Your Buyer Want‑Listing"}</span>
    </span>
  </div>
);

const BioCard = ({ details }) => (
  <div className="pro-art__bio">
    <div className="pro-art__who">
      <Face details={details} />
      <span>
        <b>
          {details?.FirstName} {details?.LastName}
        </b>
        <span>{details?.Company}</span>
      </span>
    </div>
    <div className="pro-art__form">
      <span className="pro-art__field">Price range</span>
      <span className="pro-art__field">Areas</span>
      <span className="pro-art__send">Send to {details?.FirstName || "you"}</span>
    </div>
  </div>
);

const ShareCard = ({ details, listing }) => (
  <div className="pro-art__share">
    <span className="pro-art__share-photo" aria-hidden="true" />
    <span className="pro-art__meta">
      {listing.budget ? <b>{listing.budget}</b> : null}
      <span>{listing.title || "Your Buyer Want‑Listing"}</span>
    </span>
    <span className="pro-art__share-foot">
      <span>
        {details?.FirstName} {details?.LastName}
      </span>
      <span className="pro-art__share-icons" aria-hidden="true">
        <Facebook size={14} strokeWidth={1.75} />
        <Linkedin size={14} strokeWidth={1.75} />
        <Instagram size={14} strokeWidth={1.75} />
      </span>
      <img src={GitchaLogo} alt="" />
    </span>
  </div>
);

const BioStrip = ({ details }) => (
  <div className="pro-art__strip">
    <Face details={details} />
    <span>
      <b>
        {details?.FirstName} {details?.LastName}
      </b>
      <span>Tell {details?.FirstName || "me"} what you're looking for</span>
    </span>
  </div>
);

const ProArt = ({ feature, details, listing, compact = false }) => {
  if (compact) {
    return feature === "video" || feature === "shareCard" ? <ListingCard listing={listing} compact /> : <BioStrip details={details} />;
  }
  if (feature === "video") return <ListingCard listing={listing} />;
  if (feature === "shareCard") return <ShareCard details={details} listing={listing} />;
  return <BioCard details={details} />;
};

export default ProArt;
